// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.breadcrumb-container {
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    -webkit-overflow-scrolling: touch;

    /* Firefox */
    scrollbar-width: none;
  
    /* IE / Edge */
    -ms-overflow-style: none;
  }
  
  .breadcrumb {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    white-space: nowrap;
    height: 32px;
    gap: 8px;
    padding: 8px 0;
    margin: 0;
    list-style: none;
    
  }
  
  .breadcrumb li {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    font-size: 14px;
  }
  
  .breadcrumb span {
    color: var(--gris-principale);
    border-bottom: solid 1px var(--gris-principale);
    font-size: 15px;
    cursor: pointer;
    white-space: nowrap;
  }
  
  .separator {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 32px;
    font-size: 22px;
    line-height: 1;
    color: var(--gris-principale);
    flex-shrink: 0;
  }
  
  .breadcrumb_active {
    color: var(--couleur-principale) !important;
    border-bottom: none !important;
    font-weight: bold;
  }
  `, "",{"version":3,"sources":["webpack://./src/assets/css/breadcrumb/breadcrumb.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;IACjC,iCAAiC;;IAEjC,YAAY;IACZ,qBAAqB;;IAErB,cAAc;IACd,wBAAwB;EAC1B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,QAAQ;IACR,cAAc;IACd,SAAS;IACT,gBAAgB;;EAElB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,6BAA6B;IAC7B,+CAA+C;IAC/C,eAAe;IACf,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,6BAA6B;IAC7B,cAAc;EAChB;;EAEA;IACE,2CAA2C;IAC3C,8BAA8B;IAC9B,iBAAiB;EACnB","sourcesContent":[".breadcrumb-container {\n    width: 100%;\n    overflow-x: auto;\n    overflow-y: hidden;\n    -webkit-overflow-scrolling: touch;\n    -webkit-overflow-scrolling: touch;\n\n    /* Firefox */\n    scrollbar-width: none;\n  \n    /* IE / Edge */\n    -ms-overflow-style: none;\n  }\n  \n  .breadcrumb {\n    display: flex;\n    align-items: center;\n    flex-wrap: nowrap;\n    white-space: nowrap;\n    height: 32px;\n    gap: 8px;\n    padding: 8px 0;\n    margin: 0;\n    list-style: none;\n    \n  }\n  \n  .breadcrumb li {\n    display: flex;\n    align-items: center;\n    flex-shrink: 0;\n    font-size: 14px;\n  }\n  \n  .breadcrumb span {\n    color: var(--gris-principale);\n    border-bottom: solid 1px var(--gris-principale);\n    font-size: 15px;\n    cursor: pointer;\n    white-space: nowrap;\n  }\n  \n  .separator {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 32px;\n    font-size: 22px;\n    line-height: 1;\n    color: var(--gris-principale);\n    flex-shrink: 0;\n  }\n  \n  .breadcrumb_active {\n    color: var(--couleur-principale) !important;\n    border-bottom: none !important;\n    font-weight: bold;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
